import styled from "styled-components/macro";

import {
  borderRadius,
  colors,
  space,
  titlefontStyle,
  fontSize,
  boxShadow,
} from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";

export const StyledImageTeaser = styled.div`
  position: relative;

  border: 1px solid ${colors.grey2};
  border-radius: ${borderRadius.m};

  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  &::before {
    content: "";

    display: block;
    padding-bottom: 100%; // make square
  }

  &[type="button"] {
    &:hover {
      background-color: ${colors.grey1};
      box-shadow: ${boxShadow.l};
    }

    ${hoverFocus.defaultFocus}
  }

  @media print {
    border: none;
  }
`;

export const StyledImageTeaserOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.blackLight};

  ${titlefontStyle.bold}
  ${fontSize.xxxl}
  text-align: center;
`;

export const StyledFloatingButtonContainer = styled.div`
  position: absolute;
  margin: ${space.xs};
  right: 0;
  top: 0;

  @media print {
    display: none;
  }
`;
